import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  OrganizationBillingSettings,
  ResetOrganizationBillingSettingsInput,
  UpdateOrganizationBillingSettingsInput,
} from './organization-billing-settings.types'

export interface OrganizationBillingSettingsScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type OrganizationBillingSettingsQueryContext = Pick<
  QueryFunctionContext<[OrganizationBillingSettingsScope]>,
  'queryKey'
>

export async function getOrganizationBillingSettings({
  queryKey: [{ organizationId }],
}: OrganizationBillingSettingsQueryContext) {
  return axios.get<OrganizationBillingSettings>(
    '/customer-billing-defaults',
    buildAdminRequestConfig({ organizationId })
  )
}

export async function updateOrganizationBillingSettings({
  organizationId,
  ...values
}: UpdateOrganizationBillingSettingsInput & OrganizationBillingSettingsScope) {
  return axios.put<OrganizationBillingSettings>(
    '/customer-billing-defaults',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function resetOrganizationBillingSettings({
  organizationId,
  expectedVersion,
}: ResetOrganizationBillingSettingsInput & OrganizationBillingSettingsScope) {
  return axios.post<OrganizationBillingSettings>(
    '/customer-billing-defaults/reset',
    { expected_version: expectedVersion },
    buildAdminRequestConfig({ organizationId })
  )
}
